import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import TopIcon from '../../../Images/icons/scroll-top.png';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const Button = styled.button`
  position: fixed;
  bottom: 3%;
  right: 3%;

  width: 74px;
  height: 64px;
  border-radius: 13px;

  background: black;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transform: ${({ $visible }) =>
    $visible ? 'translateY(0)' : 'translateY(20px)'};

  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 49px;
    height: 51px;
  }
`;

const Icon = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const [hideByFooter, setHideByFooter] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const trigger = window.innerHeight;

      setVisible(scrolled > trigger);
    };

    window.addEventListener('scroll', handleScroll);

    const footer = document.querySelector('#footer');

    if (footer) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setHideByFooter(entry.isIntersecting);
        },
        {
          root: null,
          threshold: 0.1,
        }
      );

      observer.observe(footer);

      return () => {
        window.removeEventListener('scroll', handleScroll);
        observer.disconnect();
      };
    }

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const shouldShow = visible && !hideByFooter;

  return (
    <Button $visible={shouldShow} onClick={scrollToTop}>
      <Icon src={TopIcon} alt="Scroll To Top" />
    </Button>
  );
};

export default ScrollToTopButton;
